// src/GenericStencil.tsx
import { isChromatic } from "@brexhq/metal-utils";
import styled from "@emotion/styled";
import { memo, useRef } from "react";

// src/usePulseAnimationEffect.ts
import { useEffect } from "react";
var usePulseAnimationEffect = (elementRef, shouldAnimate) => {
  useEffect(() => {
    var _a;
    if (shouldAnimate === false || // the web animation API is not stubbed in the jest mocked DOM
    typeof ((_a = elementRef.current) == null ? void 0 : _a.animate) !== "function") {
      return;
    }
    const animation = elementRef.current.animate(
      [
        // from
        { opacity: 0.5 },
        // to
        { opacity: 1 }
      ],
      {
        duration: 750,
        direction: "alternate",
        easing: "ease-in-out",
        iterations: Infinity
      }
    );
    animation.startTime = 0;
    return () => animation.cancel();
  }, [shouldAnimate, elementRef]);
};

// src/GenericStencil.tsx
import { jsx } from "react/jsx-runtime";
var StyledWrapper = styled.div(
  ({
    width,
    maxWidth,
    height,
    theme: { colors, borders },
    shade = "default"
  }) => ({
    display: "flex",
    width,
    height,
    maxWidth,
    backgroundColor: shade === "default" ? colors.stencil.default : colors.stencil.inverse.default,
    borderRadius: borders.radius.default,
    borderColor: colors.transparent
  })
);
var GenericStencil = memo(
  ({ shouldAnimate = !isChromatic(), ...props }) => {
    const elementRef = useRef(null);
    usePulseAnimationEffect(elementRef, shouldAnimate);
    return /* @__PURE__ */ jsx(StyledWrapper, { "data-stencil": true, ...props, ref: elementRef });
  }
);
export {
  GenericStencil,
  usePulseAnimationEffect
};
